// extracted by mini-css-extract-plugin
export default {"main":"Detail_main__yxhmb","title":"Detail_title__0IZlQ","text":"Detail_text__FDxVZ","href":"Detail_href__BNGL7","img":"Detail_img__CS1kd","record":"Detail_record__WIryK"};